// Additive module: imported once at the end of existing quote-upload pages.
import { api, adminApi } from '@/lib/api';

export function chooseExcelSheet(names) {
  return new Promise((resolve) => {
    const previousFocus = document.activeElement;
    const dialog = document.createElement('dialog');
    dialog.style.cssText = 'border:1px solid #dce2ea;border-radius:12px;padding:24px;max-width:460px;width:90%;font-family:inherit;color:#172b46';
    const title = document.createElement('h2');
    title.textContent = 'Teklif için çalışma sayfası seçin';
    title.style.cssText = 'font-size:20px;margin:0 0 12px';
    const note = document.createElement('p');
    note.textContent = 'Yalnızca seçtiğiniz sayfadaki ürünler işlenecek.';
    const select = document.createElement('select');
    select.setAttribute('aria-label', 'Çalışma sayfası');
    select.style.cssText = 'width:100%;padding:12px;margin:8px 0 20px;border:1px solid #cbd5e1;border-radius:6px';
    const placeholder = document.createElement('option');
    placeholder.value = ''; placeholder.textContent = 'Sayfa seçin';
    select.appendChild(placeholder);
    names.forEach((name) => {
      const option = document.createElement('option');
      option.value = name; option.textContent = name;
      select.appendChild(option);
    });
    const cancel = document.createElement('button');
    cancel.type = 'button'; cancel.textContent = 'Vazgeç';
    cancel.style.cssText = 'padding:10px 16px;margin-right:8px;cursor:pointer';
    const submit = document.createElement('button');
    submit.type = 'button'; submit.textContent = 'Seçilen sayfayı oku'; submit.disabled = true;
    submit.style.cssText = 'padding:10px 16px;background:#f97316;color:white;border:0;border-radius:6px;cursor:pointer';
    let finished = false;
    const finish = (value) => {
      if (finished) return;
      finished = true; dialog.close(); dialog.remove(); previousFocus?.focus?.(); resolve(value);
    };
    select.onchange = () => { submit.disabled = !select.value; };
    submit.onclick = () => { if (select.value) finish(select.value); };
    cancel.onclick = () => finish(null);
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); finish(null); });
    dialog.append(title, note, select, cancel, submit);
    document.body.appendChild(dialog);
    dialog.showModal(); select.focus();
  });
}

for (const client of [api, adminApi]) {
if (!client.__pramidExcelSheetAddon) {
  client.__pramidExcelSheetAddon = true;
  client.interceptors.request.use(async (config) => {
    const url = String(config.url || '');
    if (!/\/quotes\/excel\/?$/.test(url) || String(config.method).toLowerCase() !== 'post' ||
        !(config.data instanceof FormData) || config.data.get('sheet_name')) return config;
    const file = config.data.get('file');
    if (!file) return config;
    const inspection = new FormData(); inspection.append('file', file);
    const response = await client.post(url.replace(/\/$/, '') + '/sheets', inspection,
      { headers: config.headers?.Authorization ? { Authorization: config.headers.Authorization } : {} });
    const sheets = response.data.sheets;
    if (!Array.isArray(sheets) || sheets.length === 0) throw new Error('Excel çalışma sayfası bulunamadı.');
    const selected = sheets.length === 1 ? sheets[0] : await chooseExcelSheet(sheets);
    if (!selected) {
      const message = 'Excel sayfa seçimi iptal edildi. Teklif oluşturulmadı.';
      throw Object.assign(new Error(message), { response: { data: { detail: message } } });
    }
    config.data.set('sheet_name', selected);
    return config;
  });
}

}
